import React from 'react';

const WIDTHS = [240, 400, 640, 800];

// Optimized, responsive headshot. Images live in /public/headshots as
// {name}-{width}.webp (intrinsic 800x1200, 3:2 portrait, ~80% quality).
export const Headshot = ({
  name,
  alt,
  className = '',
  sizes,
  eager = false,
}) => {
  const srcSet = WIDTHS.map((w) => `/headshots/${name}-${w}.webp ${w}w`).join(', ');
  return (
    <img
      src={`/headshots/${name}-640.webp`}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      width={800}
      height={1200}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      className={className}
    />
  );
};

export default Headshot;
